var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        id: "upgrade-needed",
        "show-footer": false,
        "show-title": false,
      },
      on: { cancel: _vm.cancel },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "upgrade-svg" }, [_c("UpgradeSVG")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.packUpRequired"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [_vm._t("default")], 2),
        _vm._v(" "),
        _c("div", { staticClass: "subbutton", on: { click: _vm.upgrade } }, [
          _vm._v(_vm._s(_vm.$t("message.upgradePack"))),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }